import { useEffect, useState } from "react";

// Wide screens (a computer or a tablet held sideways) keep Coach beside the exercise in
// every layout (ADR-0044). Same query as the CSS, so the two never disagree.
export const WIDE_CANVAS = "(min-width: 820px) and (min-aspect-ratio: 1/1)";

function query(): MediaQueryList | null {
  // Not every environment has it (older webviews, jsdom): narrow then.
  return typeof window.matchMedia === "function" ? window.matchMedia(WIDE_CANVAS) : null;
}

export function useWideCanvas(): boolean {
  const [wide, setWide] = useState(() => query()?.matches ?? false);
  useEffect(() => {
    const list = query();
    if (list === null) return;
    const onChange = () => {
      setWide(list.matches);
    };
    onChange();
    list.addEventListener("change", onChange);
    return () => {
      list.removeEventListener("change", onChange);
    };
  }, []);
  return wide;
}
